import * as Yup from 'yup';

export const validationSchema = Yup.object({
  description: Yup.mixed().test('Popis', '', function (value) {
    const newOrder = this.options.parent || {};

    const { archivalAidMetadata, archivalCollection, description = '' } = newOrder;

    const withAidObject = !!archivalAidMetadata?.id || !!archivalCollection?.id;
    const shortDescription = description.length < 5;

    if (withAidObject && shortDescription) {
      return this.createError({
        path: 'description',
        message: 'Předmět objednávky musí obsahovat nejméně 5 znaků',
      });
    }

    return false;
  }),
});
